import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { supabase } from '@/integrations/supabase/client'
import { X, LogOut, KeyRound } from 'lucide-react'

interface UnlockCodeModalProps {
  onSuccess: () => void
  onClose?: () => void
}

const UnlockCodeModal: React.FC<UnlockCodeModalProps> = ({ onSuccess, onClose }) => {
  const navigate = useNavigate()

  const handleUnlock = () => {
    navigate('/auth/payment-info')
  }

  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('/auth/login')
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <Card className="w-full max-w-md mx-4">
        <CardHeader className="text-center">
          <div className="flex justify-between items-center">
            <CardTitle className="text-xl font-bold">Access Pending</CardTitle>
            {onClose && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onClose}
                className="h-8 w-8 p-0"
              >
                <X className="h-4 w-4" />
              </Button>
            )}
          </div>
          <CardDescription>
            Our admin team will verify your payment and grant you access to the platform.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            onClick={handleUnlock}
            className="w-full"
          >
            <KeyRound className="mr-2 h-4 w-4" />
            Unlock
          </Button>
          <div className="text-center">
            <Button
              variant="ghost"
              onClick={handleLogout}
              className="text-gray-500 hover:text-gray-700"
            >
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default UnlockCodeModal
